import { Injectable } from '@angular/core';
import { ModelModel } from '@models/api-models/model';
import { CustomizerSummaryModel } from '@models/customizer-summary-model';
import { getTempleInclinationEnumTranslation, TempleInclinationEnum } from '@models/variant-temple-inclination';
import { LanguageService } from '@services/language.service';
import { ComponentCodeConstants } from '@shared/component-constants';

@Injectable({
	providedIn: 'root'
})
export class SummaryService {

	constructor(
		private languageService: LanguageService
	) { }

	public extractComponentSummaryInformation(component: CustomizerSummaryModel, model: ModelModel | undefined | null, templeInclination: TempleInclinationEnum | null | undefined): Array<string | undefined> {
		const componentSummary: Array<string | undefined> = [];

		if (!component.ComponentVariantByPass) {
			componentSummary.push(this.languageService.instantTranslateData(component.ComponentDescription));
		}

		if (component.VariantSize && !component.ComponentVariantSizeBypass) {
			if (component.SplittingAllowed && component.ComponentSplittingDataLeft && component.ComponentSplittingDataRight) {
				componentSummary.push(component.ComponentSplittingDataLeft);
				componentSummary.push(component.ComponentSplittingDataRight);
			}
			else {
				componentSummary.push(component.ComponentVariantSizeDescription);

				if (model?.LowTempleInclinationPossible && component.ComponentCode === ComponentCodeConstants.Temple) {
					componentSummary.push(getTempleInclinationEnumTranslation(templeInclination ?? TempleInclinationEnum.standard, this.languageService));
				}
			}
		}

		return componentSummary;
	}
}